import { useEffect, useState } from 'react'
import { CoordinateResponse, Coordinates, CoordinatesRequestData } from '../Libs/Maps/types'
import { fetchCoordinates } from '../Libs/Maps/utils'

/**
 * Hook wrapper for coordinate fetching
 *
 * @param customerFormData address data that the corresponding coordinates are requested for
 * @param googleAgreed boolean whether or not the user agreed to use google maps, because google API is used for the request
 * @returns latitude and longitude and error flag
 */
export const useCoordinates = (
  customerFormData: CoordinatesRequestData | undefined,
  mapsToken: string,
  googleAgreed?: boolean
): CoordinateResponse => {
  const [coordinates, setCoordinates] = useState<Coordinates | undefined>()
  const [geoCodeError, setGeoCodeError] = useState(false)

  useEffect(() => {
    setGeoCodeError(false)
    setCoordinates(undefined)

    fetchCoordinates(customerFormData, mapsToken, googleAgreed)
      .then(response => {
        setCoordinates(response)
        setGeoCodeError(false)
      })
      .catch(() => {
        setGeoCodeError(true)
      })
  }, [customerFormData, googleAgreed, mapsToken])

  return [coordinates, geoCodeError]
}
